export default __webpack_public_path__ + "austin_sites_na.17313833.csv";